import React from 'react';
import { useParams } from 'react-router-dom';
import { Loading, NotFound } from 'components';
import useBoardStore from 'stores/board-store';
import { genericBoardPath } from 'utils/boardMenu';
import { NoticeDetail } from '../notice/NoticeDetail';

// 전용 페이지가 없는 게시판의 상세: /community/board/:moduleNo/view?contentNo=..
export function BoardDetail(props) {
  const { moduleNo } = useParams();
  const loaded = useBoardStore((state) => state.loaded);
  const board = useBoardStore((state) => state.getBoard(moduleNo));

  if (!loaded) {
    return <Loading />;
  }

  if (!board) {
    return <NotFound />;
  }

  return (
    <NoticeDetail
      key={board.moduleNo}
      moduleNo={board.moduleNo}
      title={board.moduleTitle}
      // 게시판 설명이 없으면 게시판명을 부제로 (전용 게시판의 subjectDesc 와 같은 자리)
      desc={board.moduleDesc || board.moduleTitle}
      basePath={genericBoardPath(board.moduleNo)}
      useQueryContentNo
    />
  );
}
